export default __webpack_public_path__ + "static/media/flecha-extra-info-mobile.c3096cb9.svg";